import { render } from "./CustomRegistrationForm.vue?vue&type=template&id=17dd6b7a"
import script from "./CustomRegistrationForm.vue?vue&type=script&lang=js"
export * from "./CustomRegistrationForm.vue?vue&type=script&lang=js"

import "./CustomRegistrationForm.vue?vue&type=style&index=0&id=17dd6b7a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__